import { VisitStatus } from './VisitStatus';

export enum ExamLockedStatus {
  ExamNotesAreAllowed,
  ExamLevelOnly,
  NoLock,
}

export namespace ExamLockedStatus {
  /**
   * Determines if exam section notes can be added given the current lock status.
   * @param currentLockStatus lock status applied to the exam
   * @returns Exam section followup visit notes can be added. Regular exam fields will remain locked.
   */
  export const examNotesAreAllowed = (currentLockStatus: ExamLockedStatus) =>
    currentLockStatus == ExamLockedStatus.ExamNotesAreAllowed;

  /**
   * Determines if there is any lock applied to the exam and if regular exam entry can occur.
   * @param currentLockStatus lock status applied to the exam
   * @returns Exam entry can proceed without any blocks. Followup visit notes and exam level notes will not apply.
   */
  export const noExamLock = (currentLockStatus: ExamLockedStatus) =>
    currentLockStatus == ExamLockedStatus.NoLock;

  /**
   * Determines if there is any lock applied to the exam that would only allow exam level notes to be entered.
   * @param currentLockStatus lock status applied to the exam
   * @returns Only exam level notes can be entered for the visit. Individual exam sections cannot have data entry or followup visit notes.
   */
  export const ExamLevelAreAllowed = (currentLockStatus: ExamLockedStatus) =>
    currentLockStatus == ExamLockedStatus.ExamLevelOnly;

  export const VisitSalesItemsAreAllowed = (
    lockStatus: ExamLockedStatus,
    visitStatus: VisitStatus,
  ) => {
    return (
      lockStatus === ExamLockedStatus.NoLock &&
      ![
        VisitStatus.Finalized,
        VisitStatus.Paid,
        VisitStatus.Check_Out,
      ].includes(visitStatus)
    );
  };
}
